var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
// import { utils } from "zebulon-controls";
import { dateToString, stringToDate, numberToString, isNullOrUndefined, isPromise } from "./utils/generic";
import { ContextualMenuClient } from "./ContextualMenu";

var formatValue = function formatValue(props, value, focused) {
  // console.log(1);
  var row = props.row,
      column = props.column,
      status = props.status,
      params = props.params,
      data = props.data,
      inputType = props.inputType,
      editable = props.editable;

  var _ref = column || { dataType: props.dataType },
      dataType = _ref.dataType,
      formatFunction = _ref.formatFunction;

  var v = isNullOrUndefined(value) ? "" : value;
  if (formatFunction && inputType !== "filter" && !(focused && editable) && dataType !== "boolean") {
    v = formatFunction({ value: v, row: row, column: column, params: params, status: status, data: data });
  } else if (dataType === "boolean" && value === "") {
    v = null;
  } else if (dataType === "date" && value !== null) {
    v = dateToString(v, undefined || "dd/mm/yyyy");
  } else if (dataType === "number" && value !== null) {
    v = focused && editable ? v.toString() : numberToString(v);
  }
  return v;
};
export var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _initialiseProps.call(_this);

    _this.column = props.column || {
      dataType: props.dataType,
      id: props.id,
      index_: 0,
      caption: props.label
    };
    var value = props.value;
    _this.state = {
      value: value,
      formatedValue: formatValue(props, value, props.focused),
      loaded: true,
      focused: props.focused
    };
    // this.focused = props.focused;
    if (props.select && props.editable && props.focused) {
      var options = props.select;
      if (typeof options === "function") {
        options = options(props.row);
      }
      if (isPromise(options)) {
        _this.state.options = [];
        options.then(function (options) {
          _this.setState({ options: options });
        });
      } else {
        _this.state.options = options;
      }
    }
    return _this;
  }

  _createClass(Input, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.column = nextProps.column || {
        dataType: nextProps.dataType,
        id: nextProps.id,
        index_: 0,
        caption: nextProps.label
      };

      if (nextProps.value !== this.state.value || nextProps.focused !== this.state.focused) {
        this.setState({
          value: nextProps.value,
          formatedValue: formatValue(nextProps, nextProps.value, nextProps.focused),
          focused: nextProps.focused
        });
      }
      // this.focused = nextProps.focused;
      var options = nextProps.select;
      if (options) {
        if (isPromise(options)) {
          this.setState.options = [];
          options.then(function (options) {
            _this2.setState({ options: options });
          });
        } else {
          this.setState({ options: options });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          row = _props.row,
          editable = _props.editable,
          inputType = _props.inputType,
          hasFocus = _props.hasFocus,
          select = _props.select,
          label = _props.label,
          className = _props.className,
          style = _props.style,
          onMouseDown = _props.onMouseDown,
          onMouseUp = _props.onMouseUp,
          onDoubleClick = _props.onDoubleClick,
          onMouseOver = _props.onMouseOver,
          tabIndex = _props.tabIndex,
          id = _props.id,
          menu = _props.menu,
          component = _props.component;

      var input = void 0;
      var value = this.state.formatedValue;
      var column = this.column;
      var dataType = column.dataType;

      if (inputType !== "filter" && !((this.state.focused || this.props.column === undefined) && editable) && dataType !== "boolean") {
        input = React.createElement(
          ContextualMenuClient,
          {
            id: id,
            key: id,
            row: row,
            column: column,
            className: className || "zebulon-input zebulon-input-select",
            style: style,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseOver: onMouseOver,
            onDoubleClick: onDoubleClick,
            ref: function ref(_ref2) {
              return _this3.input = _ref2;
            },
            menu: menu,
            component: component
          },
          value
        );
      } else {
        var innerStyle = {
          textAlign: style.textAlign,
          width: "100%"
        };
        if (inputType === "filter" && dataType !== "boolean") {
          innerStyle.padding = ".4em";
          innerStyle.height = "inherit";
        }
        // label;
        var disabled = !editable || undefined;
        if (select) {
          var options = this.state.options;
          if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
            if (column.reference) {
              value = column.primaryKeyAccessorFunction({ row: row });
              options = Object.keys(options).map(function (key) {
                return {
                  id: key,
                  caption: column.accessorFunction({
                    row: _defineProperty({}, column.reference, options[key])
                  })
                };
              });
            } else {
              options = Object.values(options);
            }
            options = [{ id: undefined, label: "" }].concat(options);
          }
          input = React.createElement(
            "select",
            {
              id: id,
              key: id,
              className: className || "zebulon-input zebulon-input-select",
              onChange: this.handleChange,
              value: value,
              style: innerStyle,
              autoFocus: hasFocus,
              onFocus: this.handleFocus,
              ref: function ref(_ref3) {
                return _this3.input = _ref3;
              }
            },
            options.map(function (item, index) {
              return React.createElement(
                "option",
                {
                  key: index,
                  value: (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.id : item,
                  style: (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.style || {} : {}
                },
                (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.caption : item
              );
            })
          );
        } else if (dataType === "boolean") {
          innerStyle.width = "100%";
          innerStyle.margin = "unset";
          innerStyle.padding = "unset";
          input = React.createElement("input", {
            type: "checkbox",
            id: id,
            key: id,
            autoFocus: hasFocus,
            style: innerStyle,
            checked: this.state.value || false,
            disabled: false,
            onChange: this.handleChange,
            onFocus: onMouseDown,
            onMouseUp: onMouseUp,
            tabIndex: tabIndex,
            ref: function ref(_ref4) {
              return _this3.input = _ref4;
            }
          });
        } else {
          // let value = this.state.formatedValue;
          if (isNullOrUndefined(value) || value === "") {
            value = "";
          }
          input = React.createElement("input", {
            type: "text",
            id: id,
            key: id,
            className: className || "zebulon-table-input",
            autoFocus: hasFocus && inputType !== "filter",
            style: innerStyle,
            value: hasFocus && inputType === "filter" ? this.state.value : value,
            disabled: disabled,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: tabIndex,
            ref: function ref(_ref5) {
              return _this3.input = _ref5;
            }
          });
        }
        if (dataType === "boolean") {
          input = React.createElement(
            ContextualMenuClient,
            {
              menu: menu,
              component: component,
              id: id,
              key: id,
              row: row,
              column: column,
              className: className,
              style: Object.assign({}, style),
              onDrop: function onDrop(e) {
                return e.preventDefault();
              },
              onDoubleClick: onDoubleClick
            },
            input
          );
        } else {
          input = React.createElement(
            ContextualMenuClient,
            {
              menu: menu,
              component: component,
              id: id,
              key: id,
              row: row,
              column: column,
              style: Object.assign({}, style),
              onDrop: function onDrop(e) {
                return e.preventDefault();
              },
              onDoubleClick: onDoubleClick
            },
            input
          );
        }
      }
      if (inputType === "field") {
        input = React.createElement(
          "label",
          {
            id: id,
            key: id,
            style: {
              display: "flex",
              justifyContent: "space-between",
              padding: "0.2em"
            }
            // className={this.props.className}
          },
          column.caption,
          input
        );
      }
      return input;
    }
  }]);

  return Input;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.validateInput = function (value) {
    var v = value;
    var dataType = _this4.column.dataType;
    if (_this4.props.validateInput) {
      return _this4.props.validateInput(value);
    } else if (dataType === "number") {
      v = value.slice(value.length - 1, value.length) === "." ? value.slice(0, value.length - 1) : value;
      if (v === "-") {
        v = "";
      }
      return !isNaN(Number(v));
    } else if (dataType === "date") {
      v = value.match(/[0123456789.:/ ]+/g) || [];
      return value === "" || v.length === 1 && v[0] === value;
    }
    return true;
  };

  this.handleChange = function (e) {
    var _props2 = _this4.props,
        row = _props2.row,
        editable = _props2.editable,
        inputType = _props2.inputType,
        onChange = _props2.onChange,
        filterTo = _props2.filterTo,
        onMouseDown = _props2.onMouseDown;

    var column = _this4.column;

    var _ref6 = column || { dataType: _this4.props.dataType },
        dataType = _ref6.dataType,
        format = _ref6.format;

    if (editable) {
      var value = e.target.value,
          validatedValue = void 0;
      if (!_this4.validateInput(value)) return;
      // selection of an object
      if (column.reference && column.selectItems) {
        validatedValue = column.selectItems[e.target.value] || {};
      } else if (dataType === "boolean") {
        if (inputType === "filter" && _this4.state.value === false) validatedValue = null;else {
          validatedValue = !_this4.state.value;
          value = validatedValue;
          if (inputType !== "filter" && !_this4.props.focused) {
            onMouseDown(e);
          }
        }
      } else if (dataType === "date") {
        validatedValue = stringToDate(value, format);
      } else if (dataType === "number") {
        validatedValue = value === "" ? null : Number(value);
        if (isNaN(validatedValue)) {
          validatedValue = null;
        }
      } else {
        validatedValue = value;
      }
      if (onChange) {
        if (onChange(validatedValue, row, column, filterTo) === false) {
          return false;
        }
      }
      if (row) {
        var columnId = column.reference && column.select ? column.reference : column.id;
        row[columnId] = validatedValue;
        if (column.setForeignKeyAccessorFunction && column.reference && column.selectItems) {
          column.setForeignKeyAccessorFunction({
            value: validatedValue.pk_,
            row: row
          });
        }
      }
      _this4.setState({ formatedValue: value, value: validatedValue });
    }
  };

  this.handleBlur = function () {
    _this4.setState({
      formatedValue: formatValue(_this4.props, _this4.state.value, false)
    });
  };

  this.handleFocus = function (e) {
    var _props3 = _this4.props,
        inputType = _props3.inputType,
        onFocus = _props3.onFocus,
        row = _props3.row;

    var column = _this4.column;
    if (inputType === "filter") {
      onFocus(e, row, column);
      if (column.filterType !== "values") {
        // this.focused = true;
        var formatedValue = formatValue(_this4.props, _this4.state.value, true);
        _this4.setState({
          formatedValue: formatedValue,
          focused: true
        });
      }
    } else if (onFocus) {
      onFocus(e, row, column);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/Input.js
// module id = 107
// module chunks = 0